import React from 'react'

const MessageBar = () => {
  return (
    <div className="message-bar">
        <div className="message">
            <h4 className="message-text">Got A Heating Or Plumbing Emergency? Call 0113 467 0278</h4>
        </div>
      
    </div>
  )
}

export default MessageBar
